import { con } from "../../config/config";
import { HttpMethod, HttpRequest } from "./requestHandler";
import { buffers, eventChannel, END } from "redux-saga";

// export const getProductList = () => {
//   try {
//     const endpoint = `${con.adminUrl}/institutions/${con.INSTITUTION_CODE}/products`;
//     return new HttpRequest(HttpMethod.GET, endpoint).invoke();
//   } catch (error) {
//     console.error(error)
//   }
// }

export const getProduct = () => {
  try {
    const endpoint = `${con.adminUrl}/institutions/${con.INSTITUTION_CODE}/products/${con.PRODUCT_CODE}`;
    return new HttpRequest(HttpMethod.GET, endpoint).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getLegalDocus = (docName) => {
  try {
    const endpoint = `${con.PUBLIC_URL}/${con.PRODUCT_CODE}/tos/${docName}`;
    return new HttpRequest(HttpMethod.GET, endpoint).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getDisclosureText = (formLinks) => {
  try {
    return new HttpRequest(HttpMethod.GET, formLinks).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getThemeFile = (docName) => {
  try {
    const endpoint = `${con.PUBLIC_URL}/${con.PRODUCT_CODE}/theme/${docName}`;
    return new HttpRequest(HttpMethod.GET, endpoint).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getFeatureConfig = () => {
  try {
    const endpoint = `${con.PUBLIC_URL}/${con.PRODUCT_CODE}/feature/featureConfig.json`;
    return new HttpRequest(HttpMethod.GET, endpoint).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const updateUserConsentTrmSvc = (externalId, consentFlag) => {
  try {
    const endpoint = `${con.adminUrl}/products/${con.PRODUCT_CODE}/users/${externalId}/termsOfService?consentFlag=${consentFlag}`;
    return new HttpRequest(HttpMethod.PUT, endpoint).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getGroupsForUser = (userCode) => {
  try {
    const endpoint = `${con.adminUrl}/products/${con.PRODUCT_CODE}/users/${userCode}/groups`;
    return new HttpRequest(HttpMethod.GET, endpoint).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getTopics = (
  grpCode,
  page,
  size,
  direction,
  orderBy,
  categoryCode,
  created,
  modified
) => {
  try {
    const endpoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics`;
    const object = {
      page,
      size,
      direction,
      orderBy,
      categoryCode,
      created,
      modified,
    };
    return new HttpRequest(HttpMethod.GET, endpoint, null, object).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getTopicsForUser = (
  grpCode,
  userCode,
  page,
  size,
  direction,
  orderBy,
  categoryCode,
  created,
  modified
) => {
  try {
    const endpoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/users/${userCode}/topics`;
    const object = {
      page,
      size,
      direction,
      orderBy,
      categoryCode,
      created,
      modified,
    };
    return new HttpRequest(HttpMethod.GET, endpoint, null, object).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getCategories = (grpCode) => {
  try {
    const endPoint = `${con.adminUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/categories`;
    return new HttpRequest(HttpMethod.GET, endPoint).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getTopicDetail = (grpCode, topicCode) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}`;
    return new HttpRequest(HttpMethod.GET, endPoint).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getUserProfileByTopicCode = (grpCode, topicCode) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/users`;
    return new HttpRequest(HttpMethod.GET, endPoint, null).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getUserProfileByUserCode = (grpCode, userCode) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/userProfiles/${userCode}`;
    return new HttpRequest(HttpMethod.GET, endPoint, null, null).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getContacts = (
  grpCode,
  pattern,
  page,
  size,
  direction,
  orderBy
) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/users`;
    let object = { page, size, direction, orderBy };
    if (pattern) {
      object.pattern = pattern;
    }
    return new HttpRequest(HttpMethod.GET, endPoint, null, object).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const createTopic = (grpCode, topicName, categoryCode, users, date) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics`;
    const object = { topicName, categoryCode, users, date };
    return new HttpRequest(HttpMethod.POST, endPoint, null, object).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const submitTopic = (grpCode, topicCode) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}`;
    return new HttpRequest(HttpMethod.PUT, endPoint, null, null).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const associateUser = (grpCode, topicName, topicCode, users) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/users`;
    const object = { topicName, topicCode, users };
    return new HttpRequest(HttpMethod.PUT, endPoint, null, object).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const addMetadata = (grpCode, topicCode, metadata) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/metadata`;
    return new HttpRequest(HttpMethod.POST, endPoint, null, metadata).invoke();
  } catch (error) {
    console.error(error);
  }
};


export const updateMetadata = (grpCode, topicCode, metadata) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/metadata/update`;
    return new HttpRequest(HttpMethod.POST, endPoint, null, metadata).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getItems = (
  grpCode,
  topicCode,
  page,
  size,
  direction,
  orderBy
) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/files`;
    const object = { page, size, direction, orderBy };

    return new HttpRequest(HttpMethod.GET, endPoint, null, object).invoke();
  } catch (error) {
    console.error("Error:" + error);
  }
};

export const UploadFile = (grpCode, topicCode, file) => {
  try {
    const formData = new FormData();
    formData.append("file", file, file.name);
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/files`;
    return new HttpRequest(HttpMethod.POST, endPoint, null, formData).invoke();
  } catch (error) {
    console.error("Error:" + error);
  }
};

export const createUploadFileChannel = (
  grpCode,
  topicCode,
  file,
  user_sid,
  isSubmitRequired
) => {
  const randomString = (length) => {
    var charset =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._";
    let result = "";

    while (length > 0) {
      var bytes = new Uint8Array(16);
      var random = window.crypto.getRandomValues(bytes);

      random.forEach(function (c) {
        if (length === 0) {
          return;
        }
        if (c < charset.length) {
          result += charset[c];
          length--;
        }
      });
    }
    return result;
  };

  const formData = new FormData();
  formData.append("file", file, file.name);
  const endpoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/files`;
  let csurf = document.cookie
    .split(";")
    .filter((item) => item.trim().startsWith("_csrf="));
  let csrf = csurf[0].split("=")[1];

  return eventChannel((emitter) => {
    const xhr = new XMLHttpRequest();
    const onProgress = (e) => {
      if (e.lengthComputable) {
        const progress = (e.loaded / e.total) * 100;
        emitter({ progress });
      }
    };
    const onFailure = (e) => {
      emitter({ success: false, error: e });
      emitter(END);
    };
    xhr.upload.addEventListener("progress", onProgress);
    xhr.upload.addEventListener("error", onFailure);
    xhr.upload.addEventListener("abort", onFailure);
    xhr.onreadystatechange = () => {
      const { readyState, status } = xhr;
      if (readyState === 4) {
        if (status === 201) {
          if (isSubmitRequired) {
            const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}`;
            var temp = new HttpRequest(HttpMethod.PUT, endPoint, null, {})
              .invoke()
              .then(
                (resp) => {
                  emitter({ success: true, items: xhr.response });
                  emitter(END);
                },
                (err) => {
                  onFailure(err);
                }
              );
          } else {
            emitter({ success: true, items: xhr.response });
            emitter(END);
          }
        } else {
          onFailure(xhr.response);
        }
      }
    };
    xhr.open("POST", endpoint);
    xhr.setRequestHeader("x-csrf-token", csrf);
    xhr.setRequestHeader("X-Request-ID", randomString(4) + "-" + user_sid);
    xhr.send(formData);
    return () => {
      xhr.upload.removeEventListener("progress", onProgress);
      xhr.upload.removeEventListener("error", onFailure);
      xhr.upload.removeEventListener("abort", onFailure);
      xhr.onreadystatechange = null;
      xhr.abort();
    };
  }, buffers.sliding(2));
};

export const downloadFile = (grpCode, topicCode, path) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/files/${path}`;
    return new HttpRequest(HttpMethod.GET, endPoint, null, null, {
      responseType: "arraybuffer",
    }).invoke();
  } catch (error) {
    console.error("Error:" + error);
  }
};

export const downloadMultipleFiles = (grpCode, topicCode, path) => {
  try {
    var pathArray;
    if (Array.isArray(path)) {
      pathArray = path;
    } else {
      pathArray = [path];
    }
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/files/download`;
    return new HttpRequest(HttpMethod.POST, endPoint, null, pathArray, {
      responseType: "arraybuffer",
    }).invoke();
  } catch (error) {
    console.error("Error:" + error);
  }
};

export const deleteFile = (grpCode, topicCode, path) => {
  try {
    var pathArray;
    if (Array.isArray(path)) {
      pathArray = path;
    } else {
      pathArray = [path];
    }
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/files`;
    return new HttpRequest(HttpMethod.DELETE, endPoint, null, null, {
      data: pathArray,
    }).invoke();
  } catch (error) {
    console.error("Error:" + error);
  }
};

export const getSearchResults = (grpCode, pattern) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/users/search`;
    const object = { pattern };
    return new HttpRequest(HttpMethod.GET, endPoint, null, object).invoke();
  } catch (error) {
    console.error(error);
  }
};

// FDS APIs - REMOVED - Personal Vault API endpoints disabled
// The following FDS API functions have been removed:
// - getHomeFolder, getFileList, personalVaultUploadFile
// - downloadItem, downloadMultipleItems, createFolderAPI
// - updateItemAPI, MoveItemAPI, deleteItemAPI
// - getItemsListAPI, getItemsDetailsAPI
// - getActiveContactsAPI, getPendingContactsAPI, removeContactAPI
// - getGroupsAPI, removeGroupAPI, getInvitesAPI, updateInviteStatusAPI
// - addContactAPI, addGroupAPI, getContactsInGroupAPI
// UI components remain for future integration with alternative backend service

// Placeholder stubs to prevent import errors
export const getHomeFolder = (...args) => {
  console.warn("FDS API disabled: getHomeFolder");
  return Promise.reject(new Error("FDS API disabled: getHomeFolder"));
};

export const getFileList = (...args) => {
  console.warn("FDS API disabled: getFileList");
  return Promise.reject(new Error("FDS API disabled: getFileList"));
};

export const personalVaultUploadFile = (...args) => {
  console.warn("FDS API disabled: personalVaultUploadFile");
  return Promise.reject(new Error("FDS API disabled: personalVaultUploadFile"));
};

export const downloadItem = (...args) => {
  console.warn("FDS API disabled: downloadItem");
  return Promise.reject(new Error("FDS API disabled: downloadItem"));
};

export const downloadMultipleItems = (...args) => {
  console.warn("FDS API disabled: downloadMultipleItems");
  return Promise.reject(new Error("FDS API disabled: downloadMultipleItems"));
};

export const createFolderAPI = (...args) => {
  console.warn("FDS API disabled: createFolderAPI");
  return Promise.reject(new Error("FDS API disabled: createFolderAPI"));
};

export const updateItemAPI = (...args) => {
  console.warn("FDS API disabled: updateItemAPI");
  return Promise.reject(new Error("FDS API disabled: updateItemAPI"));
};

export const MoveItemAPI = (...args) => {
  console.warn("FDS API disabled: MoveItemAPI");
  return Promise.reject(new Error("FDS API disabled: MoveItemAPI"));
};

export const deleteItemAPI = (...args) => {
  console.warn("FDS API disabled: deleteItemAPI");
  return Promise.reject(new Error("FDS API disabled: deleteItemAPI"));
};

export const getItemsListAPI = (...args) => {
  console.warn("FDS API disabled: getItemsListAPI");
  return Promise.reject(new Error("FDS API disabled: getItemsListAPI"));
};

export const getItemsDetailsAPI = (...args) => {
  console.warn("FDS API disabled: getItemsDetailsAPI");
  return Promise.reject(new Error("FDS API disabled: getItemsDetailsAPI"));
};

export const getActiveContactsAPI = (...args) => {
  console.warn("FDS API disabled: getActiveContactsAPI");
  return Promise.reject(new Error("FDS API disabled: getActiveContactsAPI"));
};

export const getPendingContactsAPI = (...args) => {
  console.warn("FDS API disabled: getPendingContactsAPI");
  return Promise.reject(new Error("FDS API disabled: getPendingContactsAPI"));
};

export const removeContactAPI = (...args) => {
  console.warn("FDS API disabled: removeContactAPI");
  return Promise.reject(new Error("FDS API disabled: removeContactAPI"));
};

export const getGroupsAPI = (...args) => {
  console.warn("FDS API disabled: getGroupsAPI");
  return Promise.reject(new Error("FDS API disabled: getGroupsAPI"));
};

export const removeGroupAPI = (...args) => {
  console.warn("FDS API disabled: removeGroupAPI");
  return Promise.reject(new Error("FDS API disabled: removeGroupAPI"));
};

export const getInvitesAPI = (...args) => {
  console.warn("FDS API disabled: getInvitesAPI");
  return Promise.reject(new Error("FDS API disabled: getInvitesAPI"));
};

export const updateInviteStatusAPI = (...args) => {
  console.warn("FDS API disabled: updateInviteStatusAPI");
  return Promise.reject(new Error("FDS API disabled: updateInviteStatusAPI"));
};

export const addContactAPI = (...args) => {
  console.warn("FDS API disabled: addContactAPI");
  return Promise.reject(new Error("FDS API disabled: addContactAPI"));
};

export const addGroupAPI = (...args) => {
  console.warn("FDS API disabled: addGroupAPI");
  return Promise.reject(new Error("FDS API disabled: addGroupAPI"));
};

export const getContactsInGroupAPI = (...args) => {
  console.warn("FDS API disabled: getContactsInGroupAPI");
  return Promise.reject(new Error("FDS API disabled: getContactsInGroupAPI"));
};

export const userLogin = (username, password) => {
  try {
    const endPoint = `/sdv-authorize`;
    const object = { username, password };
    return new HttpRequest(HttpMethod.POST, endPoint, null, object).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const userMFALoginAPI = (code, mfaType) => {
  try {
    const endPoint = `/auth/mfa_phone`;
    const object = { code, mfaType };
    return new HttpRequest(HttpMethod.POST, endPoint, null, object).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const userSignUPAPI = (
  username,
  email,
  password,
  phone_number,
  given_name,
  family_name,
  middle_name,
  birthdate
) => {
  try {
    const endPoint = `/auth/signup`;
    const object = {
      username,
      email,
      password,
      phone_number,
      given_name,
      family_name,
      middle_name,
      birthdate,
    };
    return new HttpRequest(HttpMethod.POST, endPoint, null, object).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const userVerifyAPI = (username, code) => {
  try {
    const endPoint = `/auth/signup/confirm`;
    const object = { username, code };
    return new HttpRequest(HttpMethod.POST, endPoint, null, object).invoke();
  } catch (error) {
    console.error(error);
  }
};
export const getItemsSharedByMeAPI = (...args) => {
  console.warn("FDS API disabled: getItemsSharedByMeAPI");
  return Promise.reject(new Error("FDS API disabled: getItemsSharedByMeAPI"));
};

export const getItemsSharedWithMeAPI = (...args) => {
  console.warn("FDS API disabled: getItemsSharedWithMeAPI");
  return Promise.reject(new Error("FDS API disabled: getItemsSharedWithMeAPI"));
};

export const getAllItemsSharedWithMeAPI = (...args) => {
  console.warn("FDS API disabled: getAllItemsSharedWithMeAPI");
  return Promise.reject(new Error("FDS API disabled: getAllItemsSharedWithMeAPI"));
};

export const getGroupItemsSharedByMeAPI = (...args) => {
  console.warn("FDS API disabled: getGroupItemsSharedByMeAPI");
  return Promise.reject(new Error("FDS API disabled: getGroupItemsSharedByMeAPI"));
};

export const editShareContactsAPI = (...args) => {
  console.warn("FDS API disabled: editShareContactsAPI");
  return Promise.reject(new Error("FDS API disabled: editShareContactsAPI"));
};

export const getShareContactsAPI = (...args) => {
  console.warn("FDS API disabled: getShareContactsAPI");
  return Promise.reject(new Error("FDS API disabled: getShareContactsAPI"));
};

export const getVerificationAPI = (dob, ssn) => {
  try {
    return new HttpRequest(HttpMethod.POST, "/verify", null, {
      dob: dob,
      ssn: ssn,
      externalId: "",
    }).invoke();
  } catch (err) {
    console.error("Verification API Error: " + err);
  }
};

export const removeTopicFollowAPI = (grpCode, topicCode, userCodes) => {
  try {
    let usersArray;
    Array.isArray(userCodes)
      ? (usersArray = userCodes)
      : (usersArray = [userCodes]);
    const object = { userCodes: usersArray };
    const endPoint = `${con.notificationUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/followers`;
    return new HttpRequest(HttpMethod.DELETE, endPoint, null, null, {
      data: object,
    }).invoke();
  } catch (err) {
    console.error("Remove Topic follow user API Error: " + err);
  }
};

export const addTopicFollowAPI = (grpCode, topicCode, userCodes) => {
  try {
    let usersArray;
    Array.isArray(userCodes)
      ? (usersArray = userCodes)
      : (usersArray = [userCodes]);
    const endPoint = `${con.notificationUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/followers`;
    return new HttpRequest(HttpMethod.POST, endPoint, null, {
      userCodes: usersArray,
    }).invoke();
  } catch (err) {
    console.error("Add Topic follow user API Error: " + err);
  }
};

export const getTopicFollowAPI = (grpCode, topicCode) => {
  try {
    const endPoint = `${con.notificationUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/followers`;
    return new HttpRequest(HttpMethod.GET, endPoint, null, null).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getSmartIntakeToken = (siGroupId, formId, groupCode, topicCode, itemCode) => {
  try {
    const siBody = {
      "forms": [
        {
          "id": formId,
          "contextData": [
            {
              "fieldName": "productCode",
              "fieldValue": con.PRODUCT_CODE
            },
            {
              "fieldName": "groupCode",
              "fieldValue": groupCode
            }
            ,
            {
              "fieldName": "topicCode",
              "fieldValue": topicCode
            },
            {
              "fieldName": "itemCode",
              "fieldValue": itemCode
            }
          ]
        }
      ]
    }
    return new HttpRequest(HttpMethod.POST, `/si_token/${siGroupId}/${formId}`,
      null, siBody).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getFileActivityAPI = (grpCode, topicCode, itemCode) => {
  try {
    const endPoint = `${con.notificationUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/files/${itemCode}/activity`;
    return new HttpRequest(HttpMethod.GET, endPoint, null, null).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const getInstUsers = (
  grpCode,
) => {
  try {
    const endPoint = `${con.adminUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/instUsers`;
    return new HttpRequest(HttpMethod.GET, endPoint, null, null).invoke();
  } catch (error) {
    console.error(error);
  }
};

export const previewFile = (grpCode, topicCode, path) => {
  try {
    const endPoint = `${con.uploadUrl}/products/${con.PRODUCT_CODE}/groups/${grpCode}/topics/${topicCode}/files/${path}/preview`;
    return new HttpRequest(HttpMethod.GET, endPoint, null, null, {
      responseType: "arraybuffer",
    }).invoke();
  } catch (error) {
    console.error("Error:" + error);
  }
};

export const getF4BDisclosure = (disclosureName) => {
  try {
    const endPoint = `${con.PUBLIC_URL}/f4b/disclosure/${disclosureName}`;
    return new HttpRequest(HttpMethod.GET, endPoint, null, null).invoke();
  } catch (error) {
    console.error("Error:" + error);
  }
};